





































import {Component, Vue} from "vue-property-decorator";
import {DocumentsModule, SectionsModule} from "@/store/store.helper";
import * as storeHelper from '@/store/store.helper';
import {NAVBAR_COLOR, NAVBAR_SIDE_ICON, NavBarInterface} from "@/store/types";

@Component({})

export default class TopicsSelectedList extends Vue {
    @DocumentsModule.DocumentsGetter private documentTopics;
    @DocumentsModule.DocumentsGetter private documentSelectedList;
    @DocumentsModule.DocumentsGetter private documentTopicsTitle;
    @DocumentsModule.DocumentsGetter private documentId;
    @SectionsModule.SectionsGetter private sectionByIdDocumentAndByStatus;
    @SectionsModule.SectionsGetter private sectionsByTopics;

    @storeHelper.DisplayModule.DisplayMutation private setNavBar;

    private accepted: string[];
    private topics: any;

    /**
     * @return boolean
     * @param i
     */
    findChoosedList(i): boolean {
        if (localStorage.checkedList) {
            this.accepted = localStorage.checkedList.split(',');
            return (this.accepted.indexOf(String(i)) != -1);
        } else {
            return false
        }
    }

    /**
     * @return void
     */
    public goToChooseTopics(): void {
        this.$router.push({name: 'choosetopics'})
    }

    private navigateTo(to): void {
        this.$router.push({name: to})
    }

    private async mounted() {
        const navBarPref: NavBarInterface = {
            title: this.documentSelectedList.documentSelectedListTitle,
            icon: NAVBAR_SIDE_ICON.menu,
            color: NAVBAR_COLOR.purple,
        };
        this.setNavBar(navBarPref);
        this.topics = this.$route.params.topics || [];
    }

    /**
     * @return any
     */
    public getTopicsByStatus(): any {
        return this.sectionByIdDocumentAndByStatus(0,4);
    }
}
